exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles_loading__3DbZo {\n  height: 100%;\n  width: 100%; }\n\n.styles_container__2tK5Y {\n  flex: 1 1;\n  width: 500px;\n  height: 200px; }\n\n.styles_mapContainer__3d7G4 {\n  flex: 1 1;\n  width: 1000px;\n  height: 400px; }\n\n.styles_map__3oPCR {\n  height: 100%; }\n\n.styles_filter-container__1GC_F {\n  left: 5px;\n  bottom: 35px; }\n\n.styles_textMapFilter__yluU4 {\n  color: #4D7387; }\n\n.styles_label-check__2J1hf {\n  padding: 0; }\n\n.styles_hide__38tLu {\n  display: none; }\n\n.styles_filterContainer__1o8ei {\n  margin-top: -50px;\n  margin-left: 10px; }\n\n@media only screen and (max-width: 820px) {\n  .styles_container__2tK5Y.styles_is-single__9vHSb {\n    display: block;\n    height: 65vh; }\n  .styles_filterContainer__1o8ei {\n    display: none; } }\n", ""]);

// Exports
exports.locals = {
	"loading": "styles_loading__3DbZo",
	"container": "styles_container__2tK5Y",
	"mapContainer": "styles_mapContainer__3d7G4",
	"map": "styles_map__3oPCR",
	"filter-container": "styles_filter-container__1GC_F",
	"filterContainer": "styles_filter-container__1GC_F",
	"textMapFilter": "styles_textMapFilter__yluU4",
	"label-check": "styles_label-check__2J1hf",
	"labelCheck": "styles_label-check__2J1hf",
	"hide": "styles_hide__38tLu",
	"filterContainer": "styles_filterContainer__1o8ei",
	"is-single": "styles_is-single__9vHSb",
	"isSingle": "styles_is-single__9vHSb"
};